<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="loading ? [] : itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="64">
          <v-container fluid>
            <v-row class="mt-10">
                <v-text-field
                    v-if="userId === null"
                    v-model="searchTerm"
                    label="Search user"
                    clearable
                    @input="onUpdateSearchTerm"
                ></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="startMonth" clearable label="From" @input="onUpdateFilters"></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="endMonth" clearable label="To" @input="onUpdateFilters"></v-text-field>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-model="only_error"
                    label="only error"
                    @change="onUpdateFilters"
                ></v-checkbox>
            </v-row>
          </v-container>
        </v-toolbar>

      </template>
      <template v-slot:item.error="{ item }">
          <v-simple-checkbox :value="item.error"></v-simple-checkbox>
      </template>
      <template v-slot:item.human_user__user="{ item }">
        {{ item.human_user__user }} ({{ item.human_user__employee_number }})
      </template>
      <template v-slot:item.calendar_date__start_week_date="{ item }">
        <span v-if="item.calendar_date__start_week_date">{{ item.calendar_date__start_week_date | moment("DD.MM.YYYY") }}</span>
      </template>
      <template v-slot:item.work_sum="{ item }">
        {{ getDuration(item.work_sum) }}
      </template>
      <template v-slot:item.work_tracker_sum="{ item }">
        {{ getDuration(item.work_tracker_sum) }}
      </template>
      <template v-slot:item.plan_sum="{ item }">
        {{ getDuration(item.plan_sum) }}
      </template>
      <template v-slot:item.up_work_sum="{ item }">
        {{ getDuration(item.up_work_sum) }}
      </template>
    </v-data-table>
    <TimeTrackerConfirmDialog></TimeTrackerConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEnterEvent from "@/components/TimeTracker/TimeTrackerEnterEvent";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import TimeTrackerNewDialogTime from "@/components/TimeTracker/TimeTrackerNewDialogTime";
import TimeTrackerNewDialogRange from "@/components/TimeTracker/TimeTrackerNewDialogRange";
import TimeTrackerConfirmDialog from "@/components/TimeTracker/TimeTrackerConfirmDialog";


export default {
  name: 'ContractWeekExecution',
  props: {
    subtractHeight: {type: [Number], default: 230},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    date: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserWeekDTO'},
  },

  components: {
    TimeTrackerEnterEvent,
    BaseDeleteDialog,
    TimeTrackerNewDialogTime,
    TimeTrackerNewDialogRange,
    TimeTrackerConfirmDialog,
  },

  computed: {
    ...mapGetters('CalendarDateUserWeek', ['getColumns']),
    ...mapFields('CalendarDateUserWeek', ['message_error', 'totalRecords', 'onlyFailedView', 'briefView', 'itemList',
      'options', 'options.page',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'columns_contract_execution']),
  },

  methods: {
    ...mapActions('CalendarDateUserWeek', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),
    getDuration(duration_hours) {
      let abs_duration_hours = Math.abs(duration_hours)
      let hours = Math.floor(abs_duration_hours)
      let minutes = Math.floor(abs_duration_hours * 60) % 60
      if (!duration_hours)
        return '00:00'
      if (duration_hours >= 0)
        return ' ' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
      else
        return '-' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (Math.abs(item.up_work_sum) > 2)
        return "error_flag"
      return "success_flag"
    },

    updateOptions() {
      // console.log('updateOptions ContractWeekExecution', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      console.log('updateOptions ContractWeekExecution', this.userId, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      this.filters['only_error'] = this.only_error

      if (this.startMonth) {
        this.filters['from_start_week_date'] = this.startMonth
      }
      else
        this.filters['from_start_week_date'] = null

      if (this.endMonth) {
        this.filters['to_start_week_date'] = this.endMonth
      }
      else
        this.filters['to_start_week_date'] = null

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),

  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    window.addEventListener("resize", this.onResize)
    this.searchTerm = null
    this.endMonth = new Date().toISOString().slice(0, 10)
    this.onUpdateFilters()

  },

  data() {
    return {
      localFilterDate: this.date,
      windowSize: {x: 0, y: 0,},
      startMonth: null,
      endMonth: null,
      only_error: false,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD;
}

.event_time_correction {
  background-color: #E1F5FE;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1;
}

.success_flag {
  background-color: #E8F5E9;
}
tbody tr.success_flag:nth-of-type(odd) {
  background-color: #C8E6C9 !important;
}

.error_flag {
  background-color: #FFEBEE;
}
tbody tr.error_flag:nth-of-type(odd) {
  background-color: #FFCDD2 !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eee !important;
}

.event_error {
  background-color: #FFEBEE;
}

</style>
